import { createAction } from '@reduxjs/toolkit';
import {
  REPORTS_SALES_PAGE_REQUEST,
  REPORTS_SALES_SUMMARY_REQUEST,
  REPORTS_SET_LIST_SALES_SUMMARY,
  REPORTS_SALES_TYPE_PAGE_REQUEST,
  REPORTS_SALES_TYPE_REQUEST,
  REPORTS_SET_SALES_TYPE,
  REPORTS_GROSS_PROFIT_PAGE_REQUEST,
  REPORTS_GROSS_PROFIT_REQUEST,
  REPORTS_SET_LIST_GROSS_PROFIT,
  REPORTS_PAYMENT_METHODS_PAGE_REQUEST,
  REPORTS_PAYMENT_METHODS_REQUEST,
  REPORTS_SET_PAYMENT_METHODS,
  REPORTS_ITEM_SALES_PAGE_REQUEST,
  REPORTS_ITEM_SALES_REQUEST,
  REPORTS_SET_ITEM_SALES,
  REPORTS_RESET_ITEM_SALES,
  REPORTS_CATEGORY_SALES_PAGE_REQUEST,
  REPORTS_CATEGORY_SALES_REQUEST,
  REPORTS_SET_CATEGORY_SALES,
  REPORTS_RESET_CATEGORY_SALES,
  REPORTS_BRAND_SALES_PAGE_REQUEST,
  REPORTS_SET_BRAND_SALES,
  REPORTS_RESET_BRAND_SALES,
  REPORTS_MODIFIER_SALES_PAGE_REQUEST,
  REPORTS_MODIFIER_SALES_REQUEST,
  REPORTS_SET_MODIFIER_SALES,
  REPORTS_DISCOUNTS_REQUEST,
  REPORTS_SET_DISCOUNTS,
  REPORTS_TAXES_PAGE_REQUEST,
  REPORTS_TAXES_REQUEST,
  REPORTS_SET_TAXES,
  REPORTS_GRATUITY_PAGE_REQUEST,
  REPORTS_GRATUITY_REQUEST,
  REPORTS_SET_GRATUITY,
  REPORTS_COLLECTEDBY_PAGE_REQUEST,
  REPORTS_COLLECTEDBY_REQUEST,
  REPORTS_SET_COLLECTEDBY,
  REPORTS_SERVEDBY_PAGE_REQUEST,
  REPORTS_SERVEDBY_REQUEST,
  REPORTS_SET_SERVEDBY,
  REPORTS_SALES_SUMMARY_CHANGE_DATE,
  REPORTS_SALES_SUMMARY_SET_START_END_DATE,
  REPORTS_SALES_TYPE_CHANGE_DATE,
  REPORTS_SALES_TYPE_SET_START_END_DATE,
  REPORTS_SALES_GROSS_PROFIT_CHANGE_DATE,
  REPORTS_SALES_GROSS_PROFIT_SET_START_END_DATE,
  REPORTS_SALES_PAYMENT_METHODS_CHANGE_DATE,
  REPORTS_SALES_PAYMENT_METHODS_SET_START_END_DATE,
  REPORTS_SALES_ITEM_SALES_CHANGE_DATE,
  REPORTS_SALES_ITEM_SALES_SET_START_END_DATE,
  REPORTS_SALES_CATEGORY_SALES_CHANGE_DATE,
  REPORTS_SALES_CATEGORY_SALES_SET_START_END_DATE,
  REPORTS_SALES_MODIFIER_SALES_CHANGE_DATE,
  REPORTS_SALES_MODIFIER_SALES_SET_START_END_DATE,
  REPORTS_SALES_DISCOUNTS_CHANGE_DATE,
  REPORTS_SALES_DISCOUNTS_SET_START_END_DATE,
  REPORTS_SALES_TAXES_CHANGE_DATE,
  REPORTS_SALES_TAXES_SET_START_END_DATE,
  REPORTS_SALES_GRATUITY_CHANGE_DATE,
  REPORTS_SALES_GRATUITY_SET_START_END_DATE,
  REPORTS_SALES_COLLECTEDBY_CHANGE_DATE,
  REPORTS_SALES_COLLECTEDBY_SET_START_END_DATE,
  REPORTS_SALES_SERVEDBY_CHANGE_DATE,
  REPORTS_SALES_SERVEDBY_SET_START_END_DATE,
  REPORTS_SALES_PAYMENT_METHODS_CHANGE_OUTLET,
  REPORTS_SALES_ITEM_SALES_CHANGE_OUTLET,
  REPORTS_SALES_TYPE_CHANGE_OUTLET,
  REPORTS_SALES_CATEGORY_SALES_CHANGE_OUTLET,
  REPORTS_SALES_MODIFIER_SALES_CHANGE_OUTLET,
  REPORTS_SALES_DISCOUNTS_CHANGE_OUTLET,
  REPORTS_SALES_TAXES_CHANGE_OUTLET,
  REPORTS_SALES_GRATUITY_CHANGE_OUTLET,
  REPORTS_SALES_COLLECTEDBY_CHANGE_OUTLET,
  REPORTS_SALES_SERVEDBY_CHANGE_OUTLET,
  REPORTS_SALES_SUMMARY_CHANGE_OUTLET,
  REPORTS_SALES_GROSS_PROFIT_CHANGE_OUTLET,
  REPORTS_SALES_EXPORT_SUMMARY,
  REPORTS_SALES_EXPORT_SALES_TYPE,
  REPORTS_SALES_EXPORT_GROSS_PROFIT,
  REPORTS_SALES_EXPORT_PAYMENT_METHODS,
  REPORTS_SALES_EXPORT_ITEM_SALES,
  REPORTS_SALES_EXPORT_CATEGORY_SALES,
  REPORTS_SALES_EXPORT_BRAND_SALES,
  REPORTS_SALES_EXPORT_MODIFIER_SALES,
  REPORTS_SALES_EXPORT_DISCOUNTS,
  REPORTS_SALES_EXPORT_TAXES,
  REPORTS_SALES_EXPORT_GRATUITY,
  REPORTS_SALES_EXPORT_COLECTEDBY,
  REPORTS_SALES_EXPORT_SERVEDBY,
  REPORTS_SALES_EXPORT_HOURLY_ITEM,
  REPORT_SALES_GENERAL_EXPORT,
  REPORTS_SALES_QUANTITY_SUMMARY,
  REPORTS_SALES_SET_OUTLETS,
  REPORTS_SALES_SHOW_LOADING_SPINNER,
} from './constants';

export function salesPageRequest() {
  return { type: REPORTS_SALES_PAGE_REQUEST, payload: {} };
}

/**
 *
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
export function salesSummaryRequest(query) {
  return { type: REPORTS_SALES_SUMMARY_REQUEST, payload: query };
}

export function setSalesSummary(sales) {
  return { type: REPORTS_SET_LIST_SALES_SUMMARY, payload: { sales } };
}

export function salesTypePageRequest() {
  return { type: REPORTS_SALES_TYPE_PAGE_REQUEST, payload: {} };
}

/**
 *
 * @param {Object} query
 * @param {string} query.startDate
 * @param {string} query.endDate
 * @param {number[]} query.outletIds
 * @return {import('flux-standard-action').FSAWithPayload<REPORTS_SALES_TYPE_REQUEST, query>}
 */
export function salesTypeRequest(query) {
  return { type: REPORTS_SALES_TYPE_REQUEST, payload: query };
}

export function setSalesTypes(salesTypes, totalAmount = 0) {
  return { type: REPORTS_SET_SALES_TYPE, payload: { salesTypes, totalAmount } };
}

export function grossProfitPageRequest() {
  return { type: REPORTS_GROSS_PROFIT_PAGE_REQUEST, payload: {} };
}

export function grossProfitRequest(query) {
  return { type: REPORTS_GROSS_PROFIT_REQUEST, payload: query };
}

export function setGrossProfit(grossProfit) {
  return { type: REPORTS_SET_LIST_GROSS_PROFIT, payload: { grossProfit } };
}

export function paymentMethodsPageRequest() {
  return { type: REPORTS_PAYMENT_METHODS_PAGE_REQUEST, payload: {} };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
export function paymentMethodsRequest(query) {
  return { type: REPORTS_PAYMENT_METHODS_REQUEST, payload: query };
}

export function setPaymentMethods(paymentMethods) {
  return { type: REPORTS_SET_PAYMENT_METHODS, payload: { paymentMethods } };
}

export function itemSalesPageRequest(type = 'inc') {
  return { type: REPORTS_ITEM_SALES_PAGE_REQUEST, payload: { type } };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */

export function itemSalesRequest(query) {
  return { type: REPORTS_ITEM_SALES_REQUEST, payload: query };
}

export function setItemSales(itemSales) {
  return { type: REPORTS_SET_ITEM_SALES, payload: { itemSales } };
}

export function resetItemSales() {
  return { type: REPORTS_RESET_ITEM_SALES };
}

export function categorySalesPageRequest(
  callback: (param: {
    outletIds: number[];
    startDate: string;
    endDate: string;
  }) => void
) {
  return { type: REPORTS_CATEGORY_SALES_PAGE_REQUEST, payload: { callback } };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
export function categorySalesRequest(query) {
  return { type: REPORTS_CATEGORY_SALES_REQUEST, payload: query };
}

export function setCategorySales(categorySales) {
  return { type: REPORTS_SET_CATEGORY_SALES, payload: { categorySales } };
}

export function resetCategorySales() {
  return { type: REPORTS_RESET_CATEGORY_SALES };
}

export function brandSalesPageRequest(query) {
  return { type: REPORTS_BRAND_SALES_PAGE_REQUEST, payload: query };
}

export function setBrandSales(brandSales) {
  return { type: REPORTS_SET_BRAND_SALES, payload: brandSales };
}

export function resetBrandSales() {
  return { type: REPORTS_RESET_BRAND_SALES };
}

export function modifierSalesPageRequest() {
  return { type: REPORTS_MODIFIER_SALES_PAGE_REQUEST, payload: {} };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
export function modifierSalesRequest(query) {
  return { type: REPORTS_MODIFIER_SALES_REQUEST, payload: query };
}

export function setModifierSales(
  modifierSales,
  totalQuantity = 0,
  totalGrossSales = 0,
  totalDiscount = 0,
  totalRefund = 0,
  totalNetSales = 0
) {
  return {
    type: REPORTS_SET_MODIFIER_SALES,
    payload: {
      modifierSales,
      totalQuantity,
      totalGrossSales,
      totalDiscount,
      totalRefund,
      totalNetSales,
    },
  };
}

export const discountsPageRequest = createAction<
  (param: { outletIds: number[]; startDate: string; endDate: string }) => void
>('reports/discountsPageRequest');

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
export function discountsRequest(query) {
  return { type: REPORTS_DISCOUNTS_REQUEST, payload: query };
}

export function setDiscounts(discounts) {
  return { type: REPORTS_SET_DISCOUNTS, payload: { discounts } };
}

export function taxesPageRequest() {
  return { type: REPORTS_TAXES_PAGE_REQUEST, payload: {} };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
export function taxesRequest(query) {
  return { type: REPORTS_TAXES_REQUEST, payload: query };
}

export function setTaxes(taxes) {
  return { type: REPORTS_SET_TAXES, payload: { taxes } };
}

export function gratuityPageRequest() {
  return { type: REPORTS_GRATUITY_PAGE_REQUEST, payload: {} };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
export function gratuityRequest(query) {
  return { type: REPORTS_GRATUITY_REQUEST, payload: query };
}

export function setGratuity(gratuities) {
  return { type: REPORTS_SET_GRATUITY, payload: { gratuities } };
}

export function collectedByPageRequest(
  callback: (param: {
    outletIds: number[];
    startDate: string;
    endDate: string;
  }) => void
) {
  return { type: REPORTS_COLLECTEDBY_PAGE_REQUEST, payload: { callback } };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
export function collectedByRequest(query) {
  return { type: REPORTS_COLLECTEDBY_REQUEST, payload: query };
}

export function setCollectedBy(staffs) {
  return { type: REPORTS_SET_COLLECTEDBY, payload: { staffs } };
}

export function servedByPageRequest() {
  return { type: REPORTS_SERVEDBY_PAGE_REQUEST, payload: {} };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
export function servedByRequest(query) {
  return { type: REPORTS_SERVEDBY_REQUEST, payload: query };
}

export function setServedBy(servers) {
  return { type: REPORTS_SET_SERVEDBY, payload: { servers } };
}

export function changeDateSalesSummary(startDate, endDate, outletIds) {
  return {
    type: REPORTS_SALES_SUMMARY_CHANGE_DATE,
    payload: { startDate, endDate, outletIds },
  };
}

export function setStartEndDate(startDate, endDate) {
  return {
    type: REPORTS_SALES_SUMMARY_SET_START_END_DATE,
    payload: { startDate, endDate },
  };
}

export function changeDateSalesType(startDate, endDate, outletIds) {
  return {
    type: REPORTS_SALES_TYPE_CHANGE_DATE,
    payload: { startDate, endDate, outletIds },
  };
}

export function setStartEndDateSalesType(startDate, endDate) {
  return {
    type: REPORTS_SALES_TYPE_SET_START_END_DATE,
    payload: { startDate, endDate },
  };
}

export function changeDateGrossProfit(startDate, endDate, outletIds) {
  return {
    type: REPORTS_SALES_GROSS_PROFIT_CHANGE_DATE,
    payload: { startDate, endDate, outletIds },
  };
}

export function setStartEndDateGrossProfit(startDate, endDate) {
  return {
    type: REPORTS_SALES_GROSS_PROFIT_SET_START_END_DATE,
    payload: { startDate, endDate },
  };
}

export function changeDatePaymentMethods(startDate, endDate, outletIds) {
  return {
    type: REPORTS_SALES_PAYMENT_METHODS_CHANGE_DATE,
    payload: { startDate, endDate, outletIds },
  };
}

export function setStartEndDatePaymentMethods(startDate, endDate) {
  return {
    type: REPORTS_SALES_PAYMENT_METHODS_SET_START_END_DATE,
    payload: { startDate, endDate },
  };
}

export function changeDateItemSales(startDate, endDate, outletIds, type) {
  return {
    type: REPORTS_SALES_ITEM_SALES_CHANGE_DATE,
    payload: { startDate, endDate, outletIds, type },
  };
}

export function setStartEndDateItemSales(startDate, endDate) {
  return {
    type: REPORTS_SALES_ITEM_SALES_SET_START_END_DATE,
    payload: { startDate, endDate },
  };
}

export function changeDateCategorySales(startDate, endDate, outletIds) {
  return {
    type: REPORTS_SALES_CATEGORY_SALES_CHANGE_DATE,
    payload: { startDate, endDate, outletIds },
  };
}

export function setStartEndDateCategorySales(startDate, endDate) {
  return {
    type: REPORTS_SALES_CATEGORY_SALES_SET_START_END_DATE,
    payload: { startDate, endDate },
  };
}

export function changeDateModifierSales(startDate, endDate, outletIds) {
  return {
    type: REPORTS_SALES_MODIFIER_SALES_CHANGE_DATE,
    payload: { startDate, endDate, outletIds },
  };
}

export function setStartEndDateModifierSales(startDate, endDate) {
  return {
    type: REPORTS_SALES_MODIFIER_SALES_SET_START_END_DATE,
    payload: { startDate, endDate },
  };
}

export function changeDateDiscounts(startDate, endDate, outletIds) {
  return {
    type: REPORTS_SALES_DISCOUNTS_CHANGE_DATE,
    payload: { startDate, endDate, outletIds },
  };
}

export function setStartEndDateDiscounts(startDate, endDate) {
  return {
    type: REPORTS_SALES_DISCOUNTS_SET_START_END_DATE,
    payload: { startDate, endDate },
  };
}

export function changeDateTaxes(startDate, endDate, outletIds) {
  return {
    type: REPORTS_SALES_TAXES_CHANGE_DATE,
    payload: { startDate, endDate, outletIds },
  };
}

export function setStartEndDateTaxes(startDate, endDate) {
  return {
    type: REPORTS_SALES_TAXES_SET_START_END_DATE,
    payload: { startDate, endDate },
  };
}

export function changeDateGratuity(startDate, endDate, outletIds) {
  return {
    type: REPORTS_SALES_GRATUITY_CHANGE_DATE,
    payload: { startDate, endDate, outletIds },
  };
}

export function setStartEndDateGratuity(startDate, endDate) {
  return {
    type: REPORTS_SALES_GRATUITY_SET_START_END_DATE,
    payload: { startDate, endDate },
  };
}

export function changeDateCollectedBy(startDate, endDate, outletIds) {
  return {
    type: REPORTS_SALES_COLLECTEDBY_CHANGE_DATE,
    payload: { startDate, endDate, outletIds },
  };
}

export function setStartEndDateCollectedBy(startDate, endDate) {
  return {
    type: REPORTS_SALES_COLLECTEDBY_SET_START_END_DATE,
    payload: { startDate, endDate },
  };
}

export function changeDateServedBy(startDate, endDate, outletIds) {
  return {
    type: REPORTS_SALES_SERVEDBY_CHANGE_DATE,
    payload: { startDate, endDate, outletIds },
  };
}

export function setStartEndDateServedBy(startDate, endDate) {
  return {
    type: REPORTS_SALES_SERVEDBY_SET_START_END_DATE,
    payload: { startDate, endDate },
  };
}

export function changeOutletSalesSummary(filter) {
  return { type: REPORTS_SALES_SUMMARY_CHANGE_OUTLET, payload: filter };
}

export function changeOutletSalesType(filter) {
  return { type: REPORTS_SALES_TYPE_CHANGE_OUTLET, payload: filter };
}

export function changeOutletGrossProfit(filter) {
  return { type: REPORTS_SALES_GROSS_PROFIT_CHANGE_OUTLET, payload: filter };
}

export function changeOutletPaymentMethods(filter) {
  return { type: REPORTS_SALES_PAYMENT_METHODS_CHANGE_OUTLET, payload: filter };
}

export function changeOutletItemSales(filter) {
  return { type: REPORTS_SALES_ITEM_SALES_CHANGE_OUTLET, payload: filter };
}

export function changeOutletCategorySales(filter) {
  return { type: REPORTS_SALES_CATEGORY_SALES_CHANGE_OUTLET, payload: filter };
}

export function changeOutletModifierSales(filter) {
  return { type: REPORTS_SALES_MODIFIER_SALES_CHANGE_OUTLET, payload: filter };
}

export function changeOutletDiscounts(filter) {
  return { type: REPORTS_SALES_DISCOUNTS_CHANGE_OUTLET, payload: filter };
}

export function changeOutletTaxes(filter) {
  return { type: REPORTS_SALES_TAXES_CHANGE_OUTLET, payload: filter };
}

export function changeOutletGratuity(filter) {
  return { type: REPORTS_SALES_GRATUITY_CHANGE_OUTLET, payload: filter };
}

export function changeOutletCollectedBy(filter) {
  return { type: REPORTS_SALES_COLLECTEDBY_CHANGE_OUTLET, payload: filter };
}

export function changeOutletServedBy(filter) {
  return { type: REPORTS_SALES_SERVEDBY_CHANGE_OUTLET, payload: filter };
}

export function exportSummary(query, filename, outletIds, queryParams) {
  return {
    type: REPORTS_SALES_EXPORT_SUMMARY,
    payload: { query, filename, outletIds, queryParams },
  };
}

export function exportSalesType(query, filename, outletId) {
  return {
    type: REPORTS_SALES_EXPORT_SALES_TYPE,
    payload: { query, filename, outletId },
  };
}

export function exportGrossProfit(query, filename, outletIds, queryParams) {
  return {
    type: REPORTS_SALES_EXPORT_GROSS_PROFIT,
    payload: { query, filename, outletIds, queryParams },
  };
}

export function exportPaymentMethod(query, filename, outletIds, queryParams) {
  return {
    type: REPORTS_SALES_EXPORT_PAYMENT_METHODS,
    payload: { query, filename, outletIds, queryParams },
  };
}

export function exportHourlyItem(query, filename, outletIds) {
  return {
    type: REPORTS_SALES_EXPORT_HOURLY_ITEM,
    payload: { query, filename, outletIds },
  };
}

export function exportItemBundle(query, filename, outletIds) {
  return {
    type: REPORTS_SALES_QUANTITY_SUMMARY,
    payload: { query, filename, outletIds },
  };
}

export function exportItemSales(query, filename, outletIds) {
  return {
    type: REPORTS_SALES_EXPORT_ITEM_SALES,
    payload: { query, filename, outletIds },
  };
}

export function exportCategorySales(query, filename, outletIds) {
  return {
    type: REPORTS_SALES_EXPORT_CATEGORY_SALES,
    payload: { query, filename, outletIds },
  };
}

export function exportBrandSales(query, filename, outletIds) {
  return {
    type: REPORTS_SALES_EXPORT_BRAND_SALES,
    payload: { query, filename, outletIds },
  };
}

export function exportModifierSales(query, filename, outletId) {
  return {
    type: REPORTS_SALES_EXPORT_MODIFIER_SALES,
    payload: { query, filename, outletId },
  };
}

export function exportDiscount(query, filename) {
  return { type: REPORTS_SALES_EXPORT_DISCOUNTS, payload: { query, filename } };
}

export function exportTaxes(query, filename, outletId) {
  return {
    type: REPORTS_SALES_EXPORT_TAXES,
    payload: { query, filename, outletId },
  };
}

export function exportGratuity(query, filename, outletId) {
  return {
    type: REPORTS_SALES_EXPORT_GRATUITY,
    payload: { query, filename, outletId },
  };
}

export function exportCollectedBy(query, filename, outletId) {
  return {
    type: REPORTS_SALES_EXPORT_COLECTEDBY,
    payload: { query, filename, outletId },
  };
}

export function exportServedBy(query, filename, outletId) {
  return {
    type: REPORTS_SALES_EXPORT_SERVEDBY,
    payload: { query, filename, outletId },
  };
}

export function exportGeneralReport({
  query,
  filename,
  outletIds,
  reportType,
  reportCategory,
}) {
  return {
    type: REPORT_SALES_GENERAL_EXPORT,
    payload: { query, filename, outletIds, reportType, reportCategory },
  };
}

export function setOutlets(outlets) {
  return { type: REPORTS_SALES_SET_OUTLETS, payload: { outlets } };
}

export function reportsShowLoadingSpinner(showLoadingSpinnerReport) {
  return {
    type: REPORTS_SALES_SHOW_LOADING_SPINNER,
    payload: { showLoadingSpinnerReport },
  };
}
